var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "customClass": "embroidery-confirm-view",
      "elementType": "section"
    }
  }, [_c('CustomText', {
    attrs: {
      "customClass": "embroidery-confirm-view-title text-center",
      "elementType": "h5",
      "keyTranslation": "embroideryConfirmViewStep"
    }
  }), _c('EmbroideryImagesView', {
    ref: "imagesComponent",
    attrs: {
      "itemsToPersonalize": _vm.itemsToPersonalize
    },
    on: {
      "images-loaded": _vm.imagesLoaded
    }
  }), _c('CustomContainer', {
    attrs: {
      "customClass": "embroidery-confirm-view-swatches"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "embroidery-confirm-view-swatches-list",
      "elementType": "ul"
    }
  }, _vm._l(_vm.colors, function (item, index) {
    return _c('CustomContainer', {
      key: index,
      style: {
        backgroundColor: item.name,
        color: _vm.iconCheckColor
      },
      attrs: {
        "customClass": "embroidery-confirm-view-swatches-list-colors",
        "elementType": "li",
        "id": "color-".concat(index)
      },
      on: {
        "click": function click($event) {
          return _vm.changeFontColor(item);
        }
      }
    }, [_c('CustomText', {
      attrs: {
        "customClass": "icon-check"
      }
    })], 1);
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }